import React, { useState, FormEvent, useEffect } from "react";
import { forgotPassword } from "../../api";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/images";
import { useNightMode } from "../../contexts/NightModeContext";

/** Forgot password — same API flow, glass auth card look */
const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const { isNightMode } = useNightMode();
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    document.body.classList.add('ex-theme');
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      toast.success("Reset link has been sent to your email.", {
        autoClose: 1000,
      });
    } catch (err: any) {
      const msg = err?.response?.data?.message || "Something went wrong.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ex-auth-screen">
      <div className="auth-glow-1" aria-hidden="true" />
      <div className="auth-glow-2" aria-hidden="true" />

      <form onSubmit={handleSubmit} className="ex-auth-card glass-panel shadow-premium">
        <div className="auth-logo">
          <img
            src={isNightMode ? images.eventox_logo_dark : images.eventox_light}
            alt="Eventox"
          />
        </div>
        <p className="auth-subtitle">Forgot Password</p>

        <div className="form-group">
          <label htmlFor="forgot-email">Registered Email</label>
          <input
            id="forgot-email"
            type="email"
            className="form-control"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="ex-auth-submit" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        <p className="ex-auth-footer">
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="btn btn-link"
            style={{ color: "var(--ex-brand-start)", textDecoration: "underline" }}
          >
            Back to Login
          </button>
        </p>
      </form>

      <ToastContainer />
    </div>
  );
};

export default ForgotPassword;
